"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicensesService = void 0;
class LicensesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    postApiV1CompaniesWorkspacesLicensesValidate({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/companies/workspaces/licenses/validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    postApiV2WorkspacesLicensesValidate({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v2/workspaces/licenses/validate',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1CompaniesWorkspacesLicenses() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/companies/workspaces/licenses',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.LicensesService = LicensesService;
